export default "__VITE_ASSET__Ca67zj7y__"